import { Typography } from "@circle-react-uikit/Typography";
import { ChartContainer } from "../shared/ChartContainer";
import { LoadingChartComponent } from "../shared/LoadingChartComponent";

interface OverviewStatComponentProps {
  className?: string;
  decimalPlaces?: number;
  isLoading?: boolean;
  prefix?: string;
  suffix?: string;
  title: string;
  titleLabel?: string;
  tooltip?: string;
  value: number | string;
}

const formatStatValue = (
  value: number | string,
  decimalPlaces: number,
): string => {
  if (typeof value === "string") {
    return value || "—";
  }

  return value.toLocaleString(undefined, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });
};

export const OverviewStatComponent = ({
  prefix,
  suffix,
  title,
  tooltip,
  titleLabel,
  value,
  isLoading,
  className,
  decimalPlaces = 0,
}: OverviewStatComponentProps) => {
  if (isLoading) {
    return <LoadingChartComponent type="stat" className={className} />;
  }

  const formattedValue = formatStatValue(value, decimalPlaces);

  return (
    <ChartContainer
      title={title}
      tooltip={tooltip}
      className={className}
      titleLabel={titleLabel}
    >
      <Typography.TitleLg as="div" weight="font-bold" color="text-very-dark">
        {prefix}
        {formattedValue}
        {suffix}
      </Typography.TitleLg>
    </ChartContainer>
  );
};
